export default __webpack_public_path__ + "static/media/second_place.44df2071.svg";